import 'rxjs/add/observable/empty';
import 'rxjs/add/observable/of';
import { chain } from 'icepick';
import queryString from 'query-string';
import type { Location } from '@atlassian/jira-router';
import {
	type QUERY_PARAM_EPICS,
	type QUERY_PARAM_VERSIONS,
	QUERY_PARAM_IS_INSIGHTS_OPEN,
} from '../../../model/routing/constants';
import type { SearchQueryParams } from '../../../model/routing/types';

export const setPanelsUrl = (
	panel:
		| typeof QUERY_PARAM_EPICS
		| typeof QUERY_PARAM_VERSIONS
		| typeof QUERY_PARAM_IS_INSIGHTS_OPEN,
	isOpen: boolean,
	location: Location,
) => {
	const search = chain<SearchQueryParams>({
		...queryString.parse(location.search),
	});

	if (isOpen) {
		// using 'visible' as this is what the old CMP uses
		search.set(panel, panel === QUERY_PARAM_IS_INSIGHTS_OPEN ? true : 'visible');
	} else {
		search.unset(panel);
	}

	return {
		...location,
		search: queryString.stringify(search.value()),
	};
};
